import { render, staticRenderFns } from "./MessageModalComponent.vue?vue&type=template&id=1dd7a80e&scoped=true&"
import script from "./MessageModalComponent.vue?vue&type=script&lang=js&"
export * from "./MessageModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7a80e",
  null
  
)

export default component.exports